import { assign, get } from 'lodash'

import {
  CLEAR_ATTRIBUTES,
  HIDE_CASH_FUND_WIZARD,
  POPULATE_FAKE_DATA,
  SAVE_START,
  SAVE_FINISH,
  SET_DEFAULTS,
  SELECT_FUND,
  SHOW_CASH_FUND_WIZARD,
  TOGGLE_COLLAPSE,
  UPDATE_ERRORS,
  UPDATE_FIELD,
} from './actions'

const initialState = {
  accountNumber: null,
  address: {},
  animateModal: true,
  animateStep: false,
  dobDay: null,
  dobMonth: null,
  dobYear: null,
  errors: {},
  firstName: null,
  fund: null,
  fundName: null,
  goalAmt: null,
  imageUrl: null,
  lastName: null,
  nameOnAccount: null,
  noGoal: false,
  notes: null,
  phoneNumber: null,
  registryOwnerHasBankAccount: false,
  routingNumber: null,
  show: false,
  step: 1,
  ui: {
    showHowItWorks: false,
    submitting: false,
  },
}

export default (state = initialState, action) => {
  const { errors } = action
  const newState = { ...state }
  const ui = { ...state.ui }

  switch (action.type) {
    case CLEAR_ATTRIBUTES:
      const clearAttributes = action.data || {}
      return assign({}, state, {
        errors: {},
        ...clearAttributes,
      })

    case HIDE_CASH_FUND_WIZARD:
      return assign({}, state, {
        errors: {},
        fundName: null,
        goalAmt: null,
        noGoal: false,
        notes: null,
        show: false,
        step: 1,
        ui: {
          showHowItWorks: false,
          submitting: false,
        },
      })

    case POPULATE_FAKE_DATA:
      return assign({}, state, {
        accountNumber: '000123456789',
        addressLine1: state.addressLine1 || '825 Washington St',
        addressLine2: state.addressLine2 || 'Suite 237',
        city: state.city || 'Oakland',
        dobDay: state.dobDay || '14',
        dobMonth: state.dobMonth || '2',
        dobYear: state.dobYear || '1980',
        phoneNumber: state.phoneNumber || '1-888-827-7856',
        postalCode: state.postalCode || '94607',
        routingNumber: '111000025',
        state: state.state || 'CA',
      })

    case SAVE_FINISH:
      ui.submitting = false
      return { ...state, ui }

    case SAVE_START:
      ui.submitting = true
      return { ...state, ui }

    case SELECT_FUND:
      // Map selected fund onto fund form if it's passed in
      const { fund } = action
      const fundName =
        (get(fund, 'custom') ? null : get(fund, 'title')) || state.fundName
      const goalAmt = get(fund, 'amount') || state.goalAmt
      const imageUrl = get(fund, 'image') || state.imageUrl
      const productId = get(fund, 'productId') || state.productId
      const noGoal = fund && !fund.amount ? true : state.noGoal

      return {
        ...state,
        errors: {},
        fund,
        fundName,
        goalAmt,
        imageUrl,
        noGoal,
        productId,
      }

    case SET_DEFAULTS:
      return assign({}, state, {
        address: get(action.defaults, 'currentRegistry.address'),
        firstName: get(action.defaults, 'firstName'),
        lastName: get(action.defaults, 'lastName'),
        registryOwnerHasBankAccount: get(
          action.defaults,
          'currentRegistry.ownerHasBankAccount'
        ),
      })

    case SHOW_CASH_FUND_WIZARD:
      return assign({}, state, {
        show: true,
      })

    case TOGGLE_COLLAPSE:
      ui[action.uiToggleState] = !state.ui[action.uiToggleState]
      return { ...state, ui }

    case UPDATE_ERRORS:
      ui.submitting = false
      return { ...state, errors, ui }

    case UPDATE_FIELD:
      switch (action.attr) {
        case 'noGoal':
          newState.goalAmt = null
          break
        case 'goalAmt':
          newState.noGoal = !action.value
          break
        default:
          break
      }
      // nested attribute
      if (action.attr.indexOf('.') != -1) {
        const topKey = action.attr.split('.')[0]
        const updateVal = action.attr.split('.')[1]
        newState[topKey] = { ...newState[topKey], [updateVal]: action.value }
      } else {
        newState[action.attr] = action.value
      }
      return newState

    default:
      return state
  }
}
